import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface TimerWebsocketState {
  isConnected: boolean
  error: string | null
}

const initialState: TimerWebsocketState = {
  isConnected: false,
  error: null,
}

const timerWebsocketSlice = createSlice({
  name: 'timerWS',
  initialState,
  reducers: {
    setConnectionStatus: (state, action: PayloadAction<boolean>) => {
      state.isConnected = action.payload
      if (action.payload) {
        state.error = null
      }
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
    },
    clearError: (state) => {
      state.error = null
    },
  },
})

export const { setConnectionStatus, setError, clearError } =
  timerWebsocketSlice.actions

export default timerWebsocketSlice.reducer
